import {createGrid} from "../../helpers/grids/grids";
import createElement from "../../helpers/createElement";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";
import {createCellRenderer, createDoubleClickHandler} from "../../helpers/grids/helpers";

function initUsersIndex() {
	let userRoleSelect = document.querySelector('.user-grid-role-select');

	// Init grid
	const grid = createGrid('.users-grid', {
			columnDefs: [
				{
					field: "role.display_name",
					headerName: 'Role',
					sortable: true,
				},
				{
					field: "first_name",
					headerName: 'First Name',
					sortable: true,
				},
				{
					field: "last_name",
					headerName: 'Last Name',
					sortable: true,
				},
				{
					field: "email",
					headerName: 'Email',
					sortable: true,
				},
				{
					field: "created_at",
					headerName: 'Created',
					width: 200,
					sortable: true,
				},

				{
					field: "id",
					headerName: '',
					maxWidth: 400,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const buttons = createElement(`
                            <div class="buttons">
                                <a class="btn btn-primary btn-sm" href="${params.data.detail_url}">
                                    <i class="fa-solid fa-eye"></i>
                                    View
								</a>
                                <a class="btn btn-primary btn-sm" href="${params.data.edit_url}">
                                    <i class="fa-solid fa-user-pen"></i>
                                    Edit
								</a>
                                <button type="button" class="btn btn-danger btn-sm remove-user-button">
                                    <i class="fa-solid fa-trash"></i>
                                    Remove
                                </button>
                            </div>`
						)

						const deleteButton = buttons.querySelector('.remove-user-button');

						deleteButton.onclick =
							() => removeUser(params.data);

						// Remove delete button from admin
						if (params.data.id === 1) {
							deleteButton.remove();
						}

						return buttons;
					})
				},
			],
			paginationPageSize: 20,
			_rowName: 'Users',
			rowClass: 'cursor-pointer',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				loading();
				// noinspection JSUnresolvedVariable
				window.location.href = data.edit_url;
			}),
		},
		window['routes/admin.users.grid'],
		() => {
			return {
				role: userRoleSelect.value
			}
		}
	);

	// Refresh grid on role change
	userRoleSelect.onchange = () => grid._refresh();

	/** Methods */

	function removeUser(user) {
		swalConfirm({
			title: 'Are you sure you want to delete this user?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(user.remove_url)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})

	}

	/** Methods */


}

export {
	initUsersIndex
}
